"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEETING_STATUS = void 0;
var MEETING_STATUS = exports.MEETING_STATUS = {
  PENDING: 'pending',
  STARTED: 'started',
  ENDED: 'ended',
  FAILED: 'failed'
};